import React from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router';

import { DateProcess } from './DateProcess';

export const Tool = (props: RouteComponentProps) => (
  <Switch>
    <Route path={`${props.match.path}/dateprocess`} component={DateProcess} />
  </Switch>
);



// WEBPACK FOOTER //
// ./src/screens/tools/Tool.tsx